<template>
  <div class="subclaim-tree">
    <div
      v-for="(subclaim, index) in subclaims"
      :key="'subclaim-' + level + '-' + index"
      class="subclaim-item"
      :class="'level-' + level"
    >
      <div class="subclaim-header">
        <v-icon x-small :color="level === 0 ? 'secondary' : 'purple'" class="mr-1">
          mdi-chevron-right
        </v-icon>
        <span class="subclaim-text">{{ subclaim.claim }}</span>
      </div>

      <!-- Nested subclaims (recursive call) -->
      <div v-if="subclaim.subclaims && subclaim.subclaims.length > 0" class="ml-4 mt-2">
        <subclaim-tree :subclaims="subclaim.subclaims" :level="level + 1"></subclaim-tree>
      </div>

      <!-- Evidence at subclaim level -->
      <div
        v-if="subclaim.evidence && subclaim.evidence.length > 0"
        class="evidence-section ml-4 mt-2"
      >
        <div class="section-label-small mb-1">
          <v-icon x-small color="success" class="mr-1">mdi-file-document</v-icon>
          <span>Evidence</span>
        </div>
        <div class="evidence-list mt-1">
          <div
            v-for="(evidence, evIndex) in subclaim.evidence"
            :key="'ev-' + level + '-' + index + '-' + evIndex"
            class="evidence-item"
          >
            <v-chip
              x-small
              class="evidence-chip"
              :color="getEvidenceTypeColor(evidence.type)"
              outlined
            >
              <v-icon x-small left>{{ getEvidenceIcon(evidence.type) }}</v-icon>
              <span class="evidence-id">{{ evidence.id }}</span>
              <span class="evidence-title">{{ evidence.title }}</span>
            </v-chip>
            <v-chip
              x-small
              class="evidence-type-badge ml-1"
              :color="getEvidenceTypeColor(evidence.type)"
              dark
            >
              {{ evidence.type }}
            </v-chip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubclaimTree',
  props: {
    subclaims: {
      type: Array,
      required: true,
    },
    level: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    getEvidenceTypeColor(type) {
      const colorMap = {
        Document: 'blue',
        Diagram: 'purple',
        'Test Report': 'green',
        'Audit Report': 'orange',
        Report: 'orange',
        'Review Report': 'indigo',
        Data: 'teal',
        'Log Data': 'cyan',
        'Contractual Document': 'deep-purple',
        'Policy Document': 'pink',
      };
      return colorMap[type] || 'grey';
    },
    getEvidenceIcon(type) {
      const iconMap = {
        Document: 'mdi-file-document',
        Diagram: 'mdi-chart-box',
        'Test Report': 'mdi-test-tube',
        'Audit Report': 'mdi-clipboard-check',
        Report: 'mdi-clipboard-text',
        'Review Report': 'mdi-file-search',
        Data: 'mdi-database',
        'Log Data': 'mdi-math-log',
        'Contractual Document': 'mdi-file-sign',
        'Policy Document': 'mdi-shield-account',
      };
      return iconMap[type] || 'mdi-file';
    },
  },
};
</script>
